import { Check } from '@phosphor-icons/react';
import { Stack } from '@reelplicate/ui';

import { PERMISSIONS, ROLES } from './roles';

/**
 * Figma "Team — Roles & permissions" (328:2342): a table of what each role
 * can do - a 112px column per role (name + one-line summary), a check or a
 * dash per permission.
 */
export function RolesTable() {
  return (
    <Stack gap={6}>
      <div className="bg-bg-surface border-border-subtle overflow-x-auto rounded-lg border px-6">
        <table className="w-full min-w-[720px] border-collapse">
          <caption className="sr-only">What each role can do</caption>
          <thead>
            <tr className="border-border-subtle border-b">
              <th
                scope="col"
                className="text-label-md text-text-secondary pt-5 pb-4 text-left align-bottom"
              >
                What each role can do
              </th>
              {ROLES.map((role) => (
                <th
                  key={role.id}
                  scope="col"
                  className="w-28 pt-5 pb-4 align-bottom font-normal"
                >
                  <Stack gap={0.5} align="center">
                    <span className="text-body-md-strong text-text-primary">
                      {role.name}
                    </span>
                    <span className="text-caption text-text-secondary">
                      {role.summary}
                    </span>
                  </Stack>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {PERMISSIONS.map((permission) => (
              <tr
                key={permission.label}
                className="border-border-subtle border-b last:border-b-0"
              >
                <th scope="row" className="py-4 text-left font-normal">
                  <Stack gap={0.5}>
                    <span className="text-body-md-strong text-text-primary">
                      {permission.label}
                    </span>
                    <span className="text-caption text-text-secondary">
                      {permission.detail}
                    </span>
                  </Stack>
                </th>
                {ROLES.map((role) => {
                  const allowed = permission.roles.includes(role.id);
                  return (
                    <td key={role.id} className="py-4 text-center">
                      {allowed ? (
                        <Check
                          aria-label="Yes"
                          className="text-icon-brand inline size-[18px]"
                        />
                      ) : (
                        <span className="text-body-sm text-text-tertiary">
                          <span aria-hidden>—</span>
                          <span className="sr-only">No</span>
                        </span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-body-sm text-text-secondary">
        Owners can change anyone’s role from the Members tab. Every workspace keeps at
        least one owner.
      </p>
    </Stack>
  );
}
